import { render, staticRenderFns } from "./CertificadosBasePantalla.vue?vue&type=template&id=2b0928ea&"
import script from "./CertificadosBasePantalla.vue?vue&type=script&lang=ts&"
export * from "./CertificadosBasePantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2b0928ea', component.options)
    } else {
      api.reload('2b0928ea', component.options)
    }
    module.hot.accept("./CertificadosBasePantalla.vue?vue&type=template&id=2b0928ea&", function () {
      api.rerender('2b0928ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/CertificadosBase/CertificadosBasePantalla.vue"
export default component.exports